import React from 'react';

import { formatCurrency, formatDate } from '../../../lib/utils';

const FundDetailsCard = ({ fund, toggleModal, isIsraeli, permissions }) => (
    <div className="fund fund-card-content flex-justify">
        <div className="fund-card-left">
            <div className="fund-name">
                <h4>{fund.name}</h4>
                {permissions.manageAccounting && <button className="btn btn-primary btn-small icon-right" onClick={toggleModal}>View/Edit Fund Info</button>}
            </div>
            <p className="medium-text"><i className="icon-home icon-left accent-text2 middle"></i>{fund.bankName}</p>
            <p className="medium-text"><i className="icon-user icon-left accent-text2 middle"></i>Account #{fund.accountNumber}</p>
            <p className="medium-text accent-text"><i className="icon-clock icon-left middle"></i>Last Activity on {formatDate(fund.lastUpdated)} by {fund.lastUpdatedBy}</p>
        </div>
        <div className="fund-card-right flex-center">
            <div className="flex-center">
                <div>
                    <i className="icon-notebook icon-left gradient-icon"></i>
                </div>
                <div>
                    <p className="xs-text accent-text uppercase-text">Book Balance</p>
                    <p className="xl-text">{formatCurrency(fund.bookBalance, isIsraeli)}</p>
                </div>
            </div>
            <hr />
            <div className="flex-center">
                <div>
                    <i className="icon-check icon-left gradient-icon"></i>
                </div>
                <div>
                    <p className="xs-text accent-text uppercase-text">Approved Applications</p>
                    <p className="xl-text accent-text3">{formatCurrency(fund.totalApproved, isIsraeli)}</p>
                </div>
            </div>
            <hr />
            <div className="flex-center">
                <div>
                    <i className="icon-wallet icon-left gradient-icon"></i>
                </div>
                <div>
                    <p className="xs-text accent-text uppercase-text">Available Balance</p>
                    <p className={`xl-text ${fund.availableBalance < 0 ? 'error-text' : 'approved-text'}`}>{formatCurrency(fund.availableBalance, isIsraeli)}</p>
                </div>
            </div>
        </div>
    </div>
);

export default FundDetailsCard;


// WEBPACK FOOTER //
// ./src/components/accountingComponents/fundDetails/FundDetailsCard.jsx